import { BASE_IMAGES } from "../../mediaSources"

export const HEROSECTION_MEDIA_SOURCES = {
    heroSection: {
        leftImageSet: {
            img: {
                defaultSrc: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-768.webp`,
                width: 768,
                height: 768,
                alt: ""
            },
            srcSet: [
                { width: 220, height: 220, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-220.webp`, type: "image/webp" },
                { width: 340, height: 340, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-340.webp`, type: "image/webp" },
                { width: 480, height: 480, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-480.webp`, type: "image/webp" },
                { width: 640, height: 640, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-640.webp`, type: "image/webp" },
                { width: 768, height: 768, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-768.webp`, type: "image/webp" },
                { width: 1024, height: 1024, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-1024.webp`, type: "image/webp" },
                { width: 1280, height: 1280, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-1280.webp`, type: "image/webp" },
                { width: 1600, height: 1600, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-1600.webp`, type: "image/webp" },
                { width: 1920, height: 1920, src: `${BASE_IMAGES}/HeroSection/mexicanSaucesBig-1920.webp`, type: "image/webp" }
            ],
        },
        rightImageSet: {
            img: {
                defaultSrc: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-768.webp`,
                width: 768,
                height: 768,
                alt: ""
            },
            srcSet: [
                { media: "(min-width: 1920px)", width: 1920, height: 1920, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-1920.webp`, type: "image/webp" },
                { media: "(min-width: 1600px)", width: 1600, height: 1600, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-1280.webp`, type: "image/webp" },
                { media: "(min-width: 1280px)", width: 1280, height: 1280, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-1024.webp`, type: "image/webp" },
                { media: "(min-width: 1024px)", width: 1024, height: 1024, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-768.webp`, type: "image/webp" },
                { media: "(min-width: 768px)", width: 768, height: 768, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-640.webp`, type: "image/webp" },
                { media: "(min-width: 640px)", width: 640, height: 640, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-480.webp`, type: "image/webp" },
                { media: "(min-width: 480px)", width: 480, height: 480, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-340.webp`, type: "image/webp" },
                { media: "(min-width: 0px)", width: 340, height: 340, src: `${BASE_IMAGES}/HeroSection/tacosDishBigOriginal-340.webp`, type: "image/webp" }
            ],
        }
    }
}